var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    id: "praise-consumption-medium",
    "data-supported-dps": "24x24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "reactions-praise-consumption-medium-a",
    x: 1,
    y: 1,
    width: 22.37,
    height: 22,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12 0a12 12 0 0112 12 12 12 0 01-12 12A12 12 0 010 12 12 12 0 0112 0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11,
    fill: "#6dae4f"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11,
    fill: "#6dae4f"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#reactions-praise-consumption-medium-a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.86 15l-.71-.53s-.29-2.82-.8-3.36a9.23 9.23 0 01-1.91-3.75c-.24-.83-.41-1.12-1.16-1.14a1.14 1.14 0 00-1 1.26 8.47 8.47 0 00.1 1.13 16.13 16.13 0 00.9 2.89l-.28-.22-6.88-5.2a1.18 1.18 0 00-1.74.11 1.11 1.11 0 00-.17.92 1.14 1.14 0 00.58.74l3.54 2.66 1.06.8-5.66-4.26a1.18 1.18 0 00-.89-.33 1.17 1.17 0 00-.84.44 1.11 1.11 0 00-.17.92 1.1 1.1 0 00.57.74l3.54 2.66 2.12 1.6-4.6-3.46a1.11 1.11 0 00-1.9 1 1.1 1.1 0 00.57.74l3.54 2.66 1.77 1.33-3.54-2.63a1.18 1.18 0 00-.9-.35 1.19 1.19 0 00-.84.41 1.12 1.12 0 00-.19.94 1.15 1.15 0 00.57.77L11 19.38a4.31 4.31 0 003.28.79l1.06.8a12.33 12.33 0 002.48-2.57 17.72 17.72 0 002-3.4z",
    fill: "#dcf0cb",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.61 11.76L14.55 11",
    fill: "#93d870",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1 13.94c-.11-.83-.19-3.31-.57-3.71a6.71 6.71 0 01-2.09-2.92c-.24-.83-.41-1.12-1.16-1.14a1.14 1.14 0 00-1 1.26 8.47 8.47 0 00.1 1.13 20.26 20.26 0 00.9 3.06L8.12 6.25a1.16 1.16 0 00-1.74.11A1.16 1.16 0 006.79 8l3.54 2.68 1.06.8-5.66-4.26a1.18 1.18 0 00-.89-.33 1.15 1.15 0 00-.84.44 1.12 1.12 0 00-.17.92A1.14 1.14 0 004.4 9l3.54 2.66 2.12 1.6-4.6-3.47a1.14 1.14 0 00-.89-.34 1.17 1.17 0 00-.85.44 1.11 1.11 0 00-.17.92 1.14 1.14 0 00.58.74l3.54 2.67 1.77 1.33-3.54-2.66a1.14 1.14 0 00-.9-.33 1.11 1.11 0 00-1 1.38 1.16 1.16 0 00.57.76L11 19.38a4.31 4.31 0 003.28.79",
    fill: "none",
    stroke: "#165209",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.78 15.48l-.7-.53s-.3-2.82-.81-3.36a9.35 9.35 0 01-1.91-3.75C19.12 7 19 6.72 18.2 6.7a1.08 1.08 0 00-.76.42 1.12 1.12 0 00-.24.88 8.47 8.47 0 00.1 1.13c.28 1.45.58 2.65.62 2.72l-6.77-5.09a1.18 1.18 0 00-1.74.11 1.11 1.11 0 00-.17.92 1.14 1.14 0 00.58.74l3.53 2.66 1.07.8-5.66-4.25a1.18 1.18 0 00-.9-.35 1.08 1.08 0 00-1 1.38 1.19 1.19 0 00.59.73L11 12.17l2.13 1.59-4.64-3.46a1.17 1.17 0 00-.9-.33 1.19 1.19 0 00-.85.44 1.15 1.15 0 00-.16.92 1.14 1.14 0 00.58.74l3.53 2.66 1.77 1.33-3.53-2.66a1.14 1.14 0 00-1.71.07 1.12 1.12 0 00-.19.94 1.16 1.16 0 00.57.76l6.33 4.74a7.09 7.09 0 003.1.94 9.75 9.75 0 001.24.65 5.07 5.07 0 003.19-2 7.61 7.61 0 001.32-4.02z",
    fill: "#ddf6d1",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.79 2.72l.35 1.56M12.75 4.63l-1.31.92M10.74 2.43l-1 2.48",
    fill: "none",
    stroke: "#165209",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.79 2.72l.35 1.56M12.75 4.63l-1.31.92M10.74 2.43l-1 2.48M7.79 2.72l.35 1.56M12.75 4.63l-1.31.92M10.74 2.43l-1 2.48",
    fill: "#231f20",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.59 13.8c.89.69 7 5.39 7.68 5.64a3.28 3.28 0 002.31 0 2.54 2.54 0 00.74-.48M18.06 7.82a18.86 18.86 0 00.69 3.79",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.71 15.48A3.24 3.24 0 0122 14.3c-.08-.33-.1-.67-.17-1a3.57 3.57 0 00-.56-1.7 9.35 9.35 0 01-1.91-3.75C19.12 7 19 6.72 18.2 6.7a1.08 1.08 0 00-.76.42 1.12 1.12 0 00-.24.88 8.47 8.47 0 00.1 1.13c.28 1.45.58 2.65.62 2.72l-6.77-5.09a1.18 1.18 0 00-1.74.11 1.11 1.11 0 00-.17.92 1.14 1.14 0 00.58.74l3.53 2.66 1.07.8-5.66-4.25a1.18 1.18 0 00-.9-.35 1.08 1.08 0 00-1 1.38 1.19 1.19 0 00.59.73L11 12.17l2.13 1.59-4.64-3.46a1.17 1.17 0 00-.9-.33 1.19 1.19 0 00-.85.44 1.15 1.15 0 00-.16.92 1.14 1.14 0 00.58.74l3.53 2.66 1.77 1.33-3.53-2.66a1.14 1.14 0 00-1.71.07 1.12 1.12 0 00-.19.94 1.16 1.16 0 00.57.76l6.33 4.74a4.12 4.12 0 001.78.77c.28.06.58.08.91.15a4.41 4.41 0 011.37.45 1.29 1.29 0 001 .08 5.85 5.85 0 002.77-2 5.67 5.67 0 001.1-3.12 1.34 1.34 0 00-.15-.76z",
    fill: "none",
    stroke: "#165209",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClap);
export default __webpack_public_path__ + "static/media/clap.fa66034b1734633f274c0218c534e275.svg";
export { ForwardRef as ReactComponent };